import React from 'react';

function Footer() {
    return <div style={{color: "white", textAlign:"center"}}>Created by Julie Schaub, University of Kansas Full Stack Boot Camp, October 2020</div>
}

export default Footer;